import React, {Component} from 'react';
import {Router, Route, hashHistory, IndexRedirect} from 'react-router';
import App from '../App';
import Login from '../pages/Login';
import Register from '../pages/Register';
import RegisterSuccess from '../pages/RegisterSuccess';
import ForgotPassword from '../pages/ForgotPassword';
import Index from '../pages/Index';
import Presentation from '../pages/Presentation';
import StationPresentation from '../pages/StationPresentation';
import StationPresentationLayout from '../pages/StationPresentationLayout';
import StationCameras from '../pages/StationCameras';
import StationDeviceDatas from '../pages/StationDeviceDatas';
import Groups from '../pages/Groups';
import Stations from '../pages/Stations';
import Accounts from '../pages/Accounts';
import Logs from '../pages/Logs';
import Statistics from '../pages/Statistics';
import Systems from '../pages/Systems';
import SystemHubs from '../pages/SystemHubs';

export default class CRouter extends Component {
  handleChange = (
    prevState, nextState, replace, callback
    ?) => {
    const {store} = this.props
    const {
      loggedIn = false
    } = store.getState().auth
    const redirectAfterLogin = nextState.location.pathname;
    if (!loggedIn) {
      replace(`/login?next=${redirectAfterLogin}`)
    }
    callback()
  }

  handleEnter = (
    nextState, replace, callback
    ?) => {
    const {store} = this.props
    const {
      loggedIn = false
    } = store.getState().auth
    const redirectAfterLogin = nextState.location.pathname;
    if (!loggedIn) {
      replace(`/login?next=${redirectAfterLogin}`)
    }
    callback()
  }

  render() {
    return (<Router history={hashHistory}>
      <Route path={'/login'} components={Login}></Route>
      <Route path={'/register'} components={Register}></Route>
      <Route path={'/forgot-password'} components={ForgotPassword}></Route>
      <Route path={'/register-success/:email'} component={RegisterSuccess}/>
      <Route path={'/'} components={App} onChange={this.handleChange} onEnter={this.handleEnter}>
        <IndexRedirect to="/index"/>
        <Route path={'index'} component={Index}/>
        <Route path={':systemID/presentation'} component={Presentation}/>
        <Route path={'station/:stationID'} component={StationPresentation}/>
        <Route path={'station/:stationID/layout'} component={StationPresentationLayout}/>
        <Route path={'station/:stationID/datas'} component={StationDeviceDatas}/>
        <Route path={'stations/:stationID/cameras'} component={StationCameras}/>
        <Route path={'groups'} component={Groups}/>
        <Route path={'stations'} component={Stations}/>
        <Route path={'users'} component={Accounts}/>
        <Route path={'logs'} component={Logs}/>
        <Route path={'statistics'} component={Statistics}/>
        <Route path={'systems'} component={Systems}/>
        <Route path={'systems/:systemID/hubs'} component={SystemHubs}/>
        <Route path={'systems/:systemID/users'} component={Accounts}/>
      </Route>
    </Router>)
  }
}



// WEBPACK FOOTER //
// ./src/routes/index.js